import { useIntl } from 'react-intl-next';

import { expValEquals } from '@confluence/feature-experiments';
import { fg } from '@confluence/feature-gating';
import { useEmptyFeed } from '@confluence/feed/entry-points/useEmptyFeed';

export const usePostOfficeHomeBannerEligible = () => {
	const { hasFeed } = useEmptyFeed();

	const { locale } = useIntl();
	const isEnglishLocale = locale.toLowerCase().startsWith('en');

	// https://switcheroo.atlassian.com/ui/gates/66f5298e-cb62-484a-9903-5c6db507bf44/key/post-office_home-banner-v2-disable-feed-check
	const isFeedEligible = fg('post-office_home-banner-v2-disable-feed-check') ? true : hasFeed;
	const isLocaleEligible = fg('post-office_confluence-home-banner-v2-locale-check')
		? isEnglishLocale
		: true;

	// https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/post_office_confluence_home_banner_experiment_-_v2/setup
	return {
		isEligible:
			isFeedEligible &&
			isLocaleEligible &&
			expValEquals('post_office_confluence_home_banner_experiment_-_v2', 'cohort', 'variation'),
	};
};
